import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Document, Page } from 'react-pdf';
import { FormattedMessage } from 'react-intl';
import { getDocumentDetails } from '../../../reducers/documents';

import './../document.css';
import messages from '../../../text/messages';

class DocumentReader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            details: undefined,
            reader: {
                numPages: null,
                pageNumber: 1
            },
            window: undefined
        };

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);

        this.close = this.close.bind(this);
        this.goToPage = this.goToPage.bind(this);
        this.onKey = this.onKey.bind(this);

        this.renderDocument = this.renderDocument.bind(this);
        this.renderPdf = this.renderPdf.bind(this);
        this.renderImage = this.renderImage.bind(this);
    }

    close() {
        this.props.onClose();
    }

    goToPage(number, relative = true) {
        const { details, reader } = this.state;
        const { pageNumber, numPages } = reader;

        if (!details || !numPages) {
            return;
        }

        let page = relative ? pageNumber + number : number;
        if (page < 1 || page > numPages) {
            return;
        }

        this.setState({ ...this.state, reader: { ...reader, pageNumber: page } });
    }

    onKey(event) {
        switch (event.code) {
            case 'Escape':
                this.close();
                break;

            case 'ArrowLeft':
                if (event.altKey || event.shiftKey) {
                    this.goToPage(1, false);
                } else {
                    this.goToPage(-1);
                }
                break;

            case 'ArrowRight':
                if (event.altKey || event.shiftKey) {
                    this.goToPage(this.state.reader.numPages, false);
                } else {
                    this.goToPage(+1);
                }
                break;

            default:
                break;
        }
    }

    renderPdf() {
        const { reader, details, window } = this.state;
        const { numPages, pageNumber } = reader;

        return (
            <div>
                <div className="text-center document-wrapper" onKeyUp={this.onKey}>
                    <Document file={details.s3_url} onLoadSuccess={this.onDocumentLoadSuccess}>
                        <Page scale={(window.height - 196) / window.height} pageNumber={pageNumber} />
                    </Document>
                </div>
                {numPages && (
                    <div className="document-reader-controls bottom no-select">
                        <div className="control">
                            <i className="material-icons" onClick={() => this.goToPage(1, false)}>
                                first_page
                            </i>
                            <i className="material-icons" onClick={() => this.goToPage(-1)}>
                                chevron_left
                            </i>
                            <span>
                                <FormattedMessage
                                    id={'pageIndicator'}
                                    defaultMessage={'{current} of {total}'}
                                    values={{ current: pageNumber, total: numPages }}
                                />
                            </span>
                            <i className="material-icons" onClick={() => this.goToPage(+1)}>
                                chevron_right
                            </i>
                            <i className="material-icons" onClick={() => this.goToPage(numPages, false)}>
                                last_page
                            </i>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    renderImage() {
        const { details } = this.state;
        return (
            <div className="text-center document-wrapper" onKeyUp={this.onKey}>
                <img src={details.s3_url} alt="" />
            </div>
        );
    }

    renderDocument() {
        const { details } = this.state;
        if (!details || !details.filename) {
            return (
                <div className="text-center document-wrapper" onKeyUp={this.onKey}>
                    <FormattedMessage {...messages.unableToRenderDocument} />
                </div>
            );
        }

        if (details.filename.indexOf('.pdf') > 0) {
            return this.renderPdf();
        }

        if (
            details.filename.indexOf('.png') > 0 ||
            details.filename.indexOf('.jpg') > 0 ||
            details.filename.indexOf('.jpeg') > 0 ||
            details.filename.indexOf('.gif') > 0
        ) {
            return this.renderImage();
        }

        return (
            <div className="text-center document-wrapper" onKeyUp={this.onKey}>
                <FormattedMessage {...messages.unableToRenderDocument} />
            </div>
        );
    }

    componentDidMount() {
        const { document, getDocumentDetails } = this.props;
        getDocumentDetails(document.id, undefined, result => this.setState({ ...this.state, details: result }));

        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        window.addEventListener('keyup', this.onKey);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('keyup', this.onKey);
    }

    updateWindowDimensions() {
        this.setState({ ...this.state, window: { width: window.innerWidth, height: window.innerHeight } });
    }

    onDocumentLoadSuccess({ numPages }) {
        this.setState({ ...this.state, reader: { ...this.state.reader, numPages: numPages } });
    }

    render() {
        const { details } = this.state;
        if (!details) return null;

        return (
            <div className="document-reader">
                <div className="document-reader-controls no-select">
                    <div className="control">
                        <i className="material-icons close-icon" onClick={this.close}>
                            close
                        </i>
                        <div className="download-icon">
                            <a href={details.s3_url} target="_blank" rel="noopener noreferrer">
                                <i className="material-icons download">publish</i>
                            </a>
                        </div>
                    </div>
                </div>
                {this.renderDocument()}
            </div>
        );
    }
}

DocumentReader.defaultProps = {
    document: undefined,
    onClose: () => null
};
DocumentReader.propTypes = {
    document: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getDocumentDetails: getDocumentDetails
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(DocumentReader);



// WEBPACK FOOTER //
// ./src/components/document/reader/index.jsx